import type {
  BlockStateDefinition,
  ImplicitDependencyGroup,
} from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import type { MenuComponentStateType, MenuComponentType } from '@unifyapps/defs/blocks/Menu/types';
import { MenuContentType } from '@unifyapps/defs/blocks/Menu/types';
import { EMPTY_ARRAY } from '@unifyapps/carbon/consts/empty';
import { lazy } from 'react';

const importMenuComponent = () =>
  import(
    /* webpackChunkName: "menu-block" */
    './Menu'
  );

const Menu = lazy(importMenuComponent);

class MenuBlockStateDefinition implements BlockStateDefinition {
  get type(): ComponentTypeUnionType {
    return 'Menu';
  }

  getEventTargetIds(block: BlockType<MenuComponentType>) {
    if (block.component.content.type === MenuContentType.STATIC) {
      return (
        block.component.content.menuItems?.map((item) => item.value) ?? (EMPTY_ARRAY as string[])
      );
    }

    return EMPTY_ARRAY as string[];
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component as MenuComponentType, ['appearance', 'componentType', 'content']),
        selectedItem: {
          id: (block.component as MenuComponentType).content.initialSelectedMenuItemId,
        },
      }) as MenuComponentStateType;
  }

  preload() {
    return {
      blockPreload: importMenuComponent,
    };
  }

  getImplicitDependencyGroups(): ImplicitDependencyGroup {
    return { isEntitySuspended: true };
  }

  getComponent() {
    return Menu;
  }
}

export default MenuBlockStateDefinition;
